import { Text, Stack, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import { Box, useTheme } from 'native-base';
import React, { useMemo } from 'react';

import { ItemDetailsComponentProps } from '../../types';

export const PrivatePensionDetailsContent: React.FC<ItemDetailsComponentProps> = ({ offer }) => {
  const theme = useTheme();
  const detailItems = useMemo(
    () => [
      {
        label: 'Nome do fundo',
        value: offer?.productNameNormalized,
      },
      {
        label: 'Tipo',
        value: offer?.productTypeNormalized,
      },
      {
        label: 'Rent. Mês',
        value: offer?.monthlyRentabilityNormalized,
      },
      {
        label: 'Rent. Ano',
        value: offer?.annualRentabilityNormalized,
      },
      {
        label: 'Rent. 12M',
        value: offer?.twelveMonthsRentabilityNormalized,
      },
      {
        label: 'Aplic. Min',
        value: offer?.minimumApplicationNormalized,
      },
      {
        label: 'Aplic. Mensal Min',
        value: offer?.monthlyMinimumApplicationNormalized,
      },
    ],
    [offer]
  );

  const spacing = Utils.Token.ToInt(theme.space, 'stack.xxxs');

  return (
    <VStack paddingTop="inset.md">
      <Box
        display="flex"
        borderRadius="sm"
        padding="inset.xs"
        backgroundColor="background"
        style={{
          rowGap: spacing,
          columnGap: spacing,
        }}
        flexDirection="row"
        flexWrap="wrap">
        {detailItems.map((item, index) => (
          <Stack
            key={`detail-item-${index}`}
            width={{ base: '45%', md: '23%' }}
            space={{ base: 0, md: 'stack.quarck' }}>
            <Text variant="semibold" fontSize="xs">
              {item.label}
            </Text>
            <Text>{item.value}</Text>
          </Stack>
        ))}
      </Box>
    </VStack>
  );
};
